import * as React from "react";

import { ProductsContext } from "./ProductsProvider";

export const useProductsState = () => {
  return React.useContext(ProductsContext);
};
